import React from 'react'
import { useTranslation } from 'react-i18next'

import TranslationNS from '@/utils/Constants/TranslationNS'
import { useAuth } from '@/middlewares/auth/auth-context'
import { useCreateEvent } from '@/contexts/create-event-context'
import EventHubDialog from '@/components/EventHub/EventHubDialog'
import OrganisationDetails from '@/components/MyAccount/OrganisationDetails'
import CreateCompetition from './index'

/**
 * Mounted once in App.js: renders the create-event modal, or the "Complete your organization
 * account" gate (moved from MyCompetitions), according to the CreateEventContext view.
 * OrganisationDetails keeps its legacy callbacks: saving flips the gate to the modal, Cancel closes.
 */
export default function CreateEventHost() {
    const { t } = useTranslation(TranslationNS.MY_COMPETITIONS)
    const authContext = useAuth()
    const { view, setView, close } = useCreateEvent()

    if (!view) return null

    if (view === 'create') {
        return (
            <CreateCompetition
                orgaId={authContext.isAdmin ? authContext.userSelect.id : authContext.user.id}
                onClose={close}
            />
        )
    }

    return (
        <EventHubDialog id="create-event-gate" title={t('Complete your organization account')} width="lg" onClose={close}>
            <OrganisationDetails
                isModal={true}
                setCreateCompetition={(value) => {
                    if (value) setView('create')
                }}
                setCompleteAccount={(value) =>
                    setView((previous) => (value ? 'gate' : previous === 'gate' ? null : previous))
                }
            />
        </EventHubDialog>
    )
}
